import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const isMobile = () => ('ontouchstart' in window || navigator.maxTouchPoints > 0);

if (!isMobile()) {
  tippy('.showcase__number', {
    theme: 'my-tippy-theme',
    placement: 'top',
    animation: 'scale',
    arrow: true,
    interactive: true,
    allowHTML: true,
    delay: [100, 50],
    trigger: 'mouseenter focus',
  });
}
